import { UserEmulationStoreState } from '../types/userEmulation.types';
import { useSelector } from 'react-redux';

export const selectUserEmulation = (state: UserEmulationStoreState) =>
	state.userEmulation;
export const useSelectUserEmulation = () => useSelector(selectUserEmulation);
